(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["herdlab-password"] && !Shopify.designMode) return;
  try {
    
  if (window.location.hash === '#enter') {
    const btn = document.querySelector('.password-footer__button');
    if (btn) btn.click();
  }
  document.querySelectorAll('.hl-pw__countdown[data-launch]').forEach((el) => {
    const target = new Date(el.dataset.launch).getTime();
    if (Number.isNaN(target)) return;
    const f = { d: el.querySelector('[data-days]'), h: el.querySelector('[data-hours]'), m: el.querySelector('[data-mins]'), s: el.querySelector('[data-secs]') };
    const pad = (n) => String(n).padStart(2, '0');
    const tick = () => {
      const diff = target - Date.now();
      if (diff <= 0) {
        el.classList.add('hl-pw__countdown--live');
        el.innerHTML = '<span class="hl-pw__live">' + (el.dataset.liveText || "We're live") + '</span>';
        clearInterval(timer);
        return;
      }
      const s = Math.floor(diff / 1000);
      f.d.textContent = Math.floor(s / 86400);
      f.h.textContent = pad(Math.floor((s % 86400) / 3600));
      f.m.textContent = pad(Math.floor((s % 3600) / 60));
      f.s.textContent = pad(s % 60);
    };
    tick();
    const timer = setInterval(tick, 1000);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["herdlab-story"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.hl-carousel').forEach((carousel) => {
    const track = carousel.querySelector('.hl-carousel__track');
    if (!track) return;
    const slides = Array.from(track.children);
    if (slides.length < 2) return;
    const dots = Array.from(carousel.querySelectorAll('[data-dot]'));
    let index = 0;
    let timer = null;
    const go = (n) => {
      index = (n + slides.length) % slides.length;
      track.scrollTo({ left: track.clientWidth * index, behavior: 'smooth' });
    };
    const sync = () => {
      const i = Math.round(track.scrollLeft / Math.max(track.clientWidth, 1));
      if (i !== index) index = i;
      dots.forEach((d, k) => {
        if (k === index) d.setAttribute('aria-current', 'true');
        else d.removeAttribute('aria-current');
      });
    };
    track.addEventListener('scroll', () => requestAnimationFrame(sync), { passive: true });
    carousel.querySelector('[data-prev]')?.addEventListener('click', () => go(index - 1));
    carousel.querySelector('[data-next]')?.addEventListener('click', () => go(index + 1));
    dots.forEach((d, k) => d.addEventListener('click', () => go(k)));
    const delay = parseInt(carousel.dataset.autoplay || '0', 10);
    if (delay >= 3000 && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      const stop = () => { if (timer) { clearInterval(timer); timer = null; } };
      const start = () => { stop(); timer = setInterval(() => go(index + 1), delay); };
      start();
      ['pointerenter', 'focusin', 'pointerdown', 'touchstart'].forEach((e) => carousel.addEventListener(e, stop, { passive: true }));
      ['pointerleave', 'focusout'].forEach((e) => carousel.addEventListener(e, () => start()));
      document.addEventListener('visibilitychange', () => (document.hidden ? stop() : start()));
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
